export default __webpack_public_path__ + "static/media/kycVerificationhelp.2c3a28be.png";